/** 账号级教学上下文：所有创作页面使用同一套学科、年级与教材版本默认值。 */
export interface TeachingContext {
  subject: string;
  grade: string;
  textbookVersion: string;
  coursewareId?: string | number;
  coursewareTitle?: string;
}

const STORAGE_KEY = 'edupaper:teaching-context';
const FALLBACK: TeachingContext = { subject: '数学', grade: '高一', textbookVersion: '人教版' };

export const teachingContextStore = {
  get(): TeachingContext {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return FALLBACK;
      return { ...FALLBACK, ...JSON.parse(raw) };
    } catch {
      return FALLBACK;
    }
  },
  set(next: TeachingContext): void {
    if (JSON.stringify(teachingContextStore.get()) === JSON.stringify(next)) return;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent<TeachingContext>('edupaper:teaching-context', { detail: next }));
  },
};

/** 已打开的创作页面订阅右上角教学范围变更，立即切换对应知识点树。 */
export const useTeachingContext = (): TeachingContext => {
  const [context, setContext] = useState<TeachingContext>(() => teachingContextStore.get());
  useEffect(() => {
    const onChange = (event: Event) => {
      setContext((event as CustomEvent<TeachingContext>).detail || teachingContextStore.get());
    };
    const onStorage = (event: StorageEvent) => {
      if (event.key === STORAGE_KEY || event.key === null) setContext(teachingContextStore.get());
    };
    window.addEventListener('edupaper:teaching-context', onChange);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('edupaper:teaching-context', onChange);
      window.removeEventListener('storage', onStorage);
    };
  }, []);
  return context;
};
import { useEffect, useState } from 'react';
